import React from 'react';
import { Wrapper, CloseIcon } from "./styled";

// the style contains only the margin given as offset
// options contains all alert given options
// message is the alert message
// close is a function that closes the alert
export const AlertTemplate = ({ options, message, close }) => (
    <Wrapper data-type={options.type}>
        <span>{message}</span>
        <CloseIcon onClick={close} />
    </Wrapper>
);

export default AlertTemplate;
